var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #004870;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M427.07,240.53c-2.28,13.02-11.27,19.53-26.98,19.53h-72.27l-22.46,63.48h-43.95l22.71-63.48h-41.26c-23.11,56.72-59.53,85.12-109.25,85.21-13.43,0-24.46-2.65-33.08-7.93-10.42-6.35-15.62-15.87-15.62-28.56,0-9.93,3.34-19.94,10.01-30.03,16.85-25.47,47.81-38.21,92.9-38.21h17.82l37.72-107.3h43.82l-38.33,107.3h41.99l31.25-88.75h44.07l-31.49,88.75h92.41ZM198.68,260.06h-3.54c-16.03,0-30.44,4.11-43.21,12.33-14.73,9.44-22.09,21.73-22.09,36.87,0,10.5,4.68,15.75,14.04,15.75,11.72,0,23.32-8.22,34.79-24.66,8.54-12.29,15.22-25.71,20.02-40.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7bad7e0ea6416b17c411f4d7e7356368.svg";
export { ForwardRef as ReactComponent };